import {
  GET_HOWITWORKS_SUCCESS,
  GET_HOWITWORKS_FAIL,
  GET_HOWITWORK_PROFILE_SUCCESS,
  GET_HOWITWORK_PROFILE_FAIL,
  ADD_HOWITWORK_SUCCESS,
  ADD_HOWITWORK_FAIL,
  UPDATE_HOWITWORK_SUCCESS,
  UPDATE_HOWITWORK_FAIL,
  DELETE_HOWITWORK_SUCCESS,
  DELETE_HOWITWORK_FAIL,
  DELETE_HOWITWORK,
  ADD_NEW_HOWITWORK,
  UPDATE_HOWITWORK
  
} from "./actionTypes";

const INIT_STATE = {
  howitworks: [],
  howitworkProfile: {
    howitwork:{},
    types:[],
    settings:[],
    services:[]
  },
  error: {},
  loading:false
};

const howitworks = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_HOWITWORKS_SUCCESS:
      return {
        ...state,
        howitworks: action.payload.data,
        total_page:action.payload.total_page
      }

    case GET_HOWITWORKS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_NEW_HOWITWORK:
        return {
          ...state,
          loading:true
        }
    case ADD_HOWITWORK_SUCCESS:
      return {
        ...state,
        howitworks: [...state.howitworks, action.payload],
        loading:false
      }

    case ADD_HOWITWORK_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_HOWITWORK:
        return {
          ...state,
          loading:true
        }
    case UPDATE_HOWITWORK_SUCCESS:
      return {
        ...state,
        howitworks: state.howitworks.map(howitwork =>
          howitwork.id.toString() === action.payload.id.toString()
            ? { ...howitwork, ...action.payload }
            : howitwork
        ),
        loading:false
      }

    case UPDATE_HOWITWORK_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_HOWITWORK:
      return {
        ...state,
        loading:true
      }
    case DELETE_HOWITWORK_SUCCESS:
      return {
        ...state,
        howitworks: state.howitworks.filter(
          howitwork => howitwork.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_HOWITWORK_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_HOWITWORK_PROFILE_SUCCESS:
      return {
        ...state,
        howitworkProfile: action.payload,
      }

    case GET_HOWITWORK_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default howitworks;
